// Modül 2 - Ünite 3, 4, 5, 6 İçerikleri
// Havayolları Adaydan Ne Bekler? - Kişilik, Dil, Görünüm, Final

const cabinCrewContentsM2U3to6 = {
  // ==================== ÜNİTE 3: KİŞİLİK ÖZELLİKLERİ ====================
  'CM-M2-U3-L1': {
    lesson_id: 'CM-M2-U3-L1',
    title: 'Aranan Kişilik Özellikleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Havayollarının Aradığı Kişilik Profili',
      paragraphs: [
        'Havayolları sadece yetenekli değil, şirket kültürüne uygun adaylar arar. Kişilik değerlendirmesi kritiktir.',
        'Takım oyuncusu: Bencil değil, işbirlikçi. Grup başarısını bireysel başarıdan önce koyar.',
        'Esneklik: Plan değişikliklerine, zor durumlara, farklı insanlara adapte olabilme.',
        'Pozitif tutum: Şikayet etmek yerine çözüm odaklı. Zorluklarda bile gülümseyebilen.',
        'Empati: Yolcuların ihtiyaçlarını anlayan, duygusal zekası yüksek.',
        'Profesyonellik: Soğukkanlı, güvenilir, tutarlı davranışlar sergileyen.'
      ],
      keyPoints: [
        'Takım ruhu en önemli özellik',
        'Esneklik ve adaptasyon yeteneği',
        'Pozitif ve çözüm odaklı yaklaşım',
        'Empati ve duygusal zeka'
      ]
    }
  },

  'CM-M2-U3-L2': {
    lesson_id: 'CM-M2-U3-L2',
    title: 'Kültürel Farkındalık',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Çok Kültürlü Ortamda Çalışma',
      paragraphs: [
        'Havacılık uluslararası bir sektördür. Farklı kültürlerden yolcular ve ekip arkadaşlarıyla çalışırsınız.',
        'Kültürel duyarlılık: Her kültürün farklı beklentileri, iletişim tarzları ve hassasiyetleri vardır.',
        'Örnek: Bazı kültürlerde göz teması saygısızlık, bazılarında samimiyet göstergesidir.',
        'Yemek tercihleri: Helal, koşer, vejetaryen, alerji... Her birini anlamak ve saygı göstermek gerekir.',
        'Mülakatta: Farklı kültürlerle deneyimlerinizi, açık fikirli olduğunuzu gösterin.'
      ],
      keyPoints: [
        'Uluslararası ortam = çok kültürlülük',
        'Her kültürün farklı beklentileri var',
        'Önyargısız ve açık fikirli olun',
        'Kültürel deneyimlerinizi paylaşın'
      ]
    }
  },

  'CM-M2-U3-L3': {
    lesson_id: 'CM-M2-U3-L3',
    title: 'Senaryo: Kültürel Durum',
    type: 'scenario',
    duration: 8,
    xp: 40,
    scenario: {
      context: 'Grup mülakatında bir tartışma başladı:',
      question: 'Bir aday "Bazı kültürlerin yolcuları daha zor" diyor. Nasıl tepki verirsiniz?',
      options: [
        { id: 'A', text: 'Haklı, bazı milletler gerçekten daha talepkar.', isCorrect: false },
        { id: 'B', text: 'Katılmıyorum, her yolcu bireysel değerlendirilmeli. Zorluklar kültürden değil, kişisel durumlardan kaynaklanır.', isCorrect: true },
        { id: 'C', text: 'Bu konuda yorum yapmak istemiyorum.', isCorrect: false },
        { id: 'D', text: 'Evet ama biz profesyoneliz, her durumda sakin kalırız.', isCorrect: false }
      ],
      feedback: {
        correct: 'Mükemmel! Genellemeden kaçındınız ve bireysel yaklaşımı vurguladınız. Bu kültürel zeka göstergesi.',
        wrong: 'Bu cevap ya önyargılı ya da pasif. Stereotiplere karşı çıkmak ve bireyselliği vurgulamak en doğrusu.'
      },
      explanation: 'Havayolları kültürel önyargıları RED eder. Herhangi bir milleti veya kültürü genelleme, açık bir eleme sebebidir.'
    }
  },

  'CM-M2-U3-L4': {
    lesson_id: 'CM-M2-U3-L4',
    title: '🎮 Kişilik Eşleştirme',
    type: 'matching',
    duration: 4,
    xp: 35,
    matching: {
      pairs: [
        { left: 'Takım oyuncusu', right: 'Grup başarısını önceliklendirir' },
        { left: 'Esneklik', right: 'Değişikliklere adapte olur' },
        { left: 'Empati', right: 'Başkalarının duygularını anlar' },
        { left: 'Profesyonellik', right: 'Her durumda tutarlı davranır' },
        { left: 'Pozitif tutum', right: 'Zorluklarda çözüm odaklı' },
        { left: 'Kültürel farkındalık', right: 'Farklılıklara saygı gösterir' }
      ]
    }
  },

  // ==================== ÜNİTE 4: DİL BECERİLERİ ====================
  'CM-M2-U4-L1': {
    lesson_id: 'CM-M2-U4-L1',
    title: 'İngilizce Gereksinimleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Havacılıkta İngilizce Şartı',
      paragraphs: [
        'İngilizce havacılığın ortak dilidir. ICAO (Uluslararası Sivil Havacılık Örgütü) bunu zorunlu kılar.',
        'Minimum seviye: Çoğu havayolu B1-B2 (Intermediate-Upper Intermediate) seviyesi ister.',
        'Premium havayolları (Emirates, Qatar, THY Uluslararası): B2-C1 seviyesi beklenebilir.',
        'Test edilen beceriler: Konuşma (en önemli), dinleme, okuma. Yazma genellikle test edilmez.',
        'Mülakatta: Akıcılık, anlaşılabilirlik ve güven önemli. Mükemmel aksan gerekli değil!'
      ],
      keyPoints: [
        'İngilizce havacılığın ortak dili',
        'B1-B2 minimum, premium için B2-C1',
        'Konuşma ve dinleme kritik',
        'Aksan değil, anlaşılabilirlik önemli'
      ]
    }
  },

  'CM-M2-U4-L2': {
    lesson_id: 'CM-M2-U4-L2',
    title: 'İkinci Dil Avantajı',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Çoklu Dil Bilmenin Faydaları',
      paragraphs: [
        'İngilizce\'nin yanında başka diller bilmek büyük avantaj sağlar.',
        'En değerli diller: Arapça (Körfez havayolları), Almanca (Lufthansa), Fransızca (Air France), Japonca, Çince.',
        'Körfez şirketleri: Arapça bilenler tercih edilir. Türkçe de bölge için değerli.',
        'Avrupa şirketleri: Yerel dil artı İngilizce ideal kombinasyon.',
        'CV\'de: Dil seviyenizi doğru belirtin. "Intermediate" yerine "B1" gibi standart ölçekler kullanın.'
      ],
      keyPoints: [
        'İkinci dil rekabet avantajı',
        'Hedef havayoluna göre dil seçin',
        'Dil seviyenizi doğru belirtin',
        'Her ek dil kapı açar'
      ]
    }
  },

  'CM-M2-U4-L3': {
    lesson_id: 'CM-M2-U4-L3',
    title: 'Etkili İletişim Teknikleri',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin İletişim Becerileri',
      paragraphs: [
        'Kabin memurluğunda iletişim sadece dil bilmek değil, ETKİLİ iletişimdir.',
        'Açık ve net: Karmaşık cümleler yerine kısa, anlaşılır ifadeler kullanın.',
        'Ses tonu: Sakin, güven verici, profesyonel. Ne çok yüksek ne çok alçak.',
        'Beden dili: Göz teması, gülümseme, açık vücut duruşu. Sözleriniz kadar önemli.',
        'Dinleme: Aktif dinleme - anlama, onaylama, uygun tepki verme.',
        'Anons yapma: Kabin anosları için net diksiyon, uygun hız ve profesyonel ton.'
      ],
      keyPoints: [
        'Açık, net, kısa cümleler',
        'Sakin ve güven verici ses tonu',
        'Beden dili sözler kadar önemli',
        'Aktif dinleme becerisi'
      ]
    }
  },

  'CM-M2-U4-L4': {
    lesson_id: 'CM-M2-U4-L4',
    title: '⚡ Dil Bilgisi Yarışı',
    type: 'timerace',
    duration: 4,
    xp: 45,
    timerace: {
      timePerQuestion: 8,
      questions: [
        { q: 'Havacılığın uluslararası dili nedir?', options: ['Almanca', 'İngilizce', 'Fransızca', 'İspanyolca'], correct: 1 },
        { q: 'ICAO ne anlama gelir?', options: ['Uluslararası Sivil Havacılık Örgütü', 'Uçak Şirketi', 'Havaalanı Kodu', 'Pilot Birliği'], correct: 0 },
        { q: 'Körfez havayolları için hangi dil avantajlı?', options: ['Çince', 'Arapça', 'Rusça', 'Portekizce'], correct: 1 },
        { q: 'B2 İngilizce ne seviyedir?', options: ['Başlangıç', 'Temel', 'Üst Orta', 'İleri'], correct: 2 },
        { q: 'Mülakatta en önemli dil becerisi?', options: ['Yazma', 'Okuma', 'Konuşma', 'Çeviri'], correct: 2 }
      ]
    }
  },

  // ==================== ÜNİTE 5: GÖRÜNÜM VE GROOMING ====================
  'CM-M2-U5-L1': {
    lesson_id: 'CM-M2-U5-L1',
    title: 'Grooming Standartları',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Kabin Ekibi Görünüm Kuralları',
      paragraphs: [
        'Kabin memurları havayolunun yüzüdür. Görünüm standartları katı ve detaylıdır.',
        'Saç: Kadınlar - topuz veya düzgün bağlı, doğal renkler. Erkekler - kısa, temiz, sakalsız veya düzgün kesilmiş sakal.',
        'Makyaj: Kadınlar - doğal ama belirgin, kırmızı ruj genellikle standart. Erkekler - temiz, bakımlı cilt.',
        'Tırnaklar: Temiz, uygun uzunluk, nötr veya kurumsal renk ojeler.',
        'Takılar: Minimal - küçük küpe, basit saat, alyans. Büyük, dikkat çekici takılar yasak.',
        'Dövme ve piercing: Görünür olmamalı. Birçok havayolu kapatılmasını zorunlu kılar.'
      ],
      keyPoints: [
        'Temiz, bakımlı, profesyonel görünüm',
        'Saç doğal renk ve düzgün şekilde',
        'Makyaj doğal ama belirgin',
        'Görünür dövme ve piercing kabul edilmez'
      ]
    }
  },

  'CM-M2-U5-L2': {
    lesson_id: 'CM-M2-U5-L2',
    title: 'Mülakat Görünümü',
    type: 'lesson',
    duration: 5,
    xp: 25,
    content: {
      title: 'Mülakat Günü Nasıl Görünmeli?',
      paragraphs: [
        'Mülakat görünümünüz, kabin memuru olarak nasıl görüneceğinizin bir önizlemesidir.',
        'Kadınlar için: Diz altı etek veya pantolon takım, açık renk bluz, kapalı burun topuklu ayakkabı (5-7 cm), saç toplanmış, kırmızı ruj.',
        'Erkekler için: Koyu renk takım elbise, beyaz veya açık mavi gömlek, kravat, temiz tıraş, parlatılmış ayakkabılar.',
        'Parfüm: Hafif, hoş, bunaltıcı değil. Hiç kullanmamak yeğlenebilir.',
        'Detaylar: Ütülü kıyafetler, temiz ayakkabılar, düzgün tırnaklar, taze nefes.',
        'Genel izlenim: "Bu kişi yarın uçağımda çalışabilir" dedirtmeli.'
      ],
      keyPoints: [
        'Mülakat = Kabin memuru önizlemesi',
        'Profesyonel, temiz, bakımlı',
        'Havayolu standartlarına uygun',
        'Detaylara dikkat edin'
      ]
    }
  },

  'CM-M2-U5-L3': {
    lesson_id: 'CM-M2-U5-L3',
    title: '🎮 Grooming Doğru/Yanlış',
    type: 'truefalse',
    duration: 4,
    xp: 35,
    truefalse: {
      statements: [
        { statement: 'Mülakatta renkli ojeler kabul edilir.', isTrue: false, explanation: 'Genellikle nötr veya kurumsal renkler tercih edilir.' },
        { statement: 'Erkek adayların temiz tıraşlı olması gerekir.', isTrue: true, explanation: 'Doğru! Çoğu havayolu temiz tıraş veya düzgün sakal ister.' },
        { statement: 'Görünür dövmeler önemli değildir.', isTrue: false, explanation: 'Yanlış! Çoğu havayolu görünür dövmeleri kabul etmez.' },
        { statement: 'Kırmızı ruj birçok havayolunda standarttır.', isTrue: true, explanation: 'Doğru! Özellikle Emirates, THY gibi şirketlerde yaygın.' },
        { statement: 'Mülakatta spor ayakkabı giyilebilir.', isTrue: false, explanation: 'Kesinlikle yanlış! Profesyonel, kapalı burun ayakkabılar gerekli.' }
      ]
    }
  },

  // ==================== ÜNİTE 6: FİNAL ====================
  'CM-M2-U6-L1': {
    lesson_id: 'CM-M2-U6-L1',
    title: '🎓 Modül 2 Final Sınavı',
    type: 'exam',
    duration: 10,
    xp: 80,
    exam: {
      questions: [
        { q: 'Havayollarının en çok aradığı kişilik özelliği nedir?', options: ['Bireysel başarı', 'Takım ruhu', 'Rekabetçilik', 'Bağımsızlık'], correct: 1 },
        { q: 'Kültürel farkındalık neden önemli?', options: ['Müşteri eleştirmek için', 'Farklılıklara saygı için', 'Kendini korumak için', 'Daha az çalışmak için'], correct: 1 },
        { q: 'Havacılıkta minimum İngilizce seviyesi genellikle:', options: ['A1', 'A2', 'B1-B2', 'C2'], correct: 2 },
        { q: 'Körfez havayolları için avantajlı dil:', options: ['Japonca', 'Arapça', 'İtalyanca', 'Portekizce'], correct: 1 },
        { q: 'Mülakatta en önemli iletişim becerisi:', options: ['Yazma', 'Konuşma', 'Okuma', 'Çeviri'], correct: 1 },
        { q: 'Kabin ekibi saç rengi nasıl olmalı?', options: ['Parlak renkler', 'Doğal renkler', 'Önemli değil', 'Sarı zorunlu'], correct: 1 },
        { q: 'Mülakatta görünür dövme hakkında:', options: ['Sorun yok', 'Kapatılmalı/kabul edilmez', 'Avantaj', 'Önemli değil'], correct: 1 },
        { q: 'Mülakat kıyafetinde ideal etek boyu:', options: ['Mini', 'Diz üstü', 'Diz altı', 'Önemli değil'], correct: 2 },
        { q: 'Aktif dinleme ne demektir?', options: ['Sessiz kalmak', 'Anlama ve uygun tepki verme', 'Sözü kesmek', 'Not almak'], correct: 1 },
        { q: 'Havayolları mülakatta neyi değerlendirir?', options: ['Sadece dil', 'Sadece görünüm', 'Hem yetenek hem kültür uyumu', 'Sadece deneyim'], correct: 2 }
      ]
    }
  }
};

export default cabinCrewContentsM2U3to6;
